module.exports = __webpack_public_path__ + "static/media/coverteye-2.170389f1.jpg";